import { useBuildTestIdInternal } from './useBuildTestIdInternal';

export interface IProps {
    testId?: string;
    identifier: string;
    suffix: string;
    componentName: string;
}

export function useBuildTestId({
    identifier,
    suffix,
    componentName,
    testId
}: IProps) {
    return useBuildTestIdInternal({
        testId,
        identifier,
        suffix,
        componentName
    });
}
